import React from 'react';
import Banner from '../Components/Pages/Android/Banner';
import Demo from '../Components/Pages/Android/Demo';
import Header from '../Components/Shared/Header/Header';
import Features1 from '../Components/Pages/MobileApp/Features';
import Features from '../Components/Pages/Home/Features';
import Innovative from '../Components/Pages/Home/Innovative';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Section from '../Components/Pages/Android/Section';
import Design from '../Components/Pages/Android/Design';
import FaqApp from '../Components/Shared/FaqApp/FaqApp';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
function Android(){
    return(
        <>
        <Header />
        <Banner />
        <Demo />
        <Features1 />
        <Innovative />
        <Section />
        <Design />
        <FaqApp />
        <Slider list={images}  styles="nobg-slider"/>
      <Features />
      <Jobs />
      <Start />
      <Footer/>
        </>
    )
};
export default Android ;